import axios from "axios";
import { getToseck } from "@/utils/toseck";
import { Message, Loading } from "element-ui";
import router from "@/router";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 150000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToseck();
    // 定义无需Token的接口白名单（根据实际项目补充）
    const whiteList = [
      '/captchaImage', // 验证码接口
      '/login',        // 登录接口
      '/register'      // 注册接口（若有）
    ];
    // 检查当前请求是否在白名单中
    const isWhiteList = whiteList.some(url => config.url.includes(url));
    if (token && !isWhiteList) { // 仅非白名单且有token时添加头
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    // 正常响应直接返回
    return res;
  },
  error => {
    // 处理HTTP错误（如网络错误、500等）
    let errorMsg = "请求失败，请稍后重试";
    if (error.response) {
      // 根据后端返回的错误信息提取消息
      if (error.response.data && error.response.data.msg) {
        errorMsg = error.response.data.msg;
      } 
      else {
        // HTTP状态码处理
        switch (error.response.status) {
          case 401:
            errorMsg = "登录已过期，请重新登录";
            // 清除token并跳转登录页
            localStorage.removeItem("token");
            router.push("/login");
            break;
          case 500:
            errorMsg = "服务器内部错误";
            break;
            case 503:
            errorMsg='系统繁忙，请稍后重试';
            break;
          default:
            errorMsg = `请求错误（${error.response.status}）`;
        }
      }
    } else if (error.message.includes('timeout')) {
      errorMsg = '请求超时，请检查网络连接';
    } else if (error.message.includes('Network Error')) {
      errorMsg = '网络错误，请检查网络连接';
    }
    Message.error(errorMsg);
    return Promise.reject(error);
  }
);


// 下载方法
export function download(url, params, filename) {
  const downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });

  return service.post(url, params, {
    transformRequest: [(params) => tansParams(params)],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob'
  }).then((data) => {
    const blob = new Blob([data]);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }).catch(() => {
    Message.error('下载文件出现错误，请联系管理员！');
  }).finally(() => {
    downloadLoadingInstance.close();
  });
}

// 参数处理
function tansParams(params) {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    if (value !== undefined && value !== null) {
      if (typeof value === 'object') {
        for (const val of Object.keys(value)) {
          const subPart = encodeURIComponent(propName + '[' + val + ']') + '=';
          result += subPart + encodeURIComponent(value[val]) + '&';
        }
      } else {
        result += propName + '=' + encodeURIComponent(value) + '&';
      }
    }
  }
  return result.slice(0, -1);
}

export default service;